import Http from "./../../../utils/Http";
// import moment from "moment-timezone";

const apiBase = "/api/v1/enterprise/tasks/";

export function createNewTask(params) {
  return Http.post(apiBase + "add-task", params);
}

export function updateTask(params) {
  return Http.post(apiBase + "edit-task", params);
}

export function getTaskList(params) {
  let url = apiBase + "get-list-of-tasks";
  let { tasktype = "", search = "", catSearch = "" } = params;
  let _getParams = [];
  // Paginated mode — used by the task library list view
  if (params.page || params.limit || params.taskType) {
    _getParams.push(`page=${params.page || 1}`);
    _getParams.push(`limit=${params.limit || 20}`);
    _getParams.push(`search=${encodeURIComponent(search)}`);
    _getParams.push(`viewArchive=${params.viewArchive || false}`);
    if (params.taskType) _getParams.push(`taskType=${params.taskType}`);
    return Http.get(url + "?" + _getParams.join("&"));
  }
  // Legacy full-list mode
  if (tasktype != "") {
    _getParams.push(`tasktype=${tasktype}`);
  }
  _getParams.push(`search=${search}`);
  _getParams.push(`catSearch=${catSearch}`);
  _getParams.push(`viewArchive=${params.viewArchive}`);
  _getParams.push(`viewallread=${params.viewallread}`);
  _getParams.push(`viewallpronunciation=${params.viewallpronunciation}`);
  _getParams.push(`viewallvideo=${params.viewallvideo}`);
  _getParams.push(`viewallquestions=${params.viewallquestions}`);
  _getParams.push(`viewallfreetextquestions=${params.viewallfreetextquestions}`);
  _getParams.push(`viewallivr=${params.viewallivr || true}`);
  _getParams.push(`viewallsoftskills=${params.viewallsoftskills || true}`);
  _getParams.push(`viewallvocabulary=${params.viewallvocabulary}`);
  url = url + "?" + _getParams.join("&");
  return Http.get(url);
}

export function getBulkTaskLibraryList(params) {
  return Http.get(apiBase + "get-all-task-list-enterprise", params);
}

export function getTaskDetailById(params) {
  let url = apiBase + "get-task-by-id";
  let _getParams = [];
  _getParams.push(`taskId=${params.taskId}`);
  url = url + "?" + _getParams.join("&");
  return Http.get(url);
}

export function getMyTaskList(params) {
  let url = apiBase + "get-my-tasks";
  let { tasktype = "", search = "", catSearch = "" } = params;
  let _getParams = [];
  if (tasktype != "") {
    _getParams.push(`tasktype=${tasktype}`);
  }
  _getParams.push(`search=${search}`);
  _getParams.push(`catSearch=${catSearch}`);
  // _getParams.push(`viewallread=${params.viewallread}`);
  // _getParams.push(`viewallpronunciation=${params.viewallpronunciation}`);
  _getParams.push(`viewallvideo=${params.viewallvideo}`);
  url = url + "?" + _getParams.join("&");
  return Http.get(url);
}

export function getContentLibraryListForTask(params) {
  let url = "/api/v1/enterprise/contentlibrary/get-video-content-for-task";
  let { contenttype = "", search = "", catSearch = "" } = params;
  let _getParams = [];
  if (contenttype != "") {
    _getParams.push(`contenttype=${contenttype}`);
  }
  _getParams.push(`search=${search}`);
  _getParams.push(`catSearch=${catSearch}`);

  url = url + "?" + _getParams.join("&");
  return Http.get(url);
}

export function getreadTypeTextForImage(params) {
  return Http.post("api/v1/public/readTypeUpload", params, {
    headers: {
      "content-type": "multipart/form-data",
    },
  });
}

export function assignTaskToUsers(params) {
  return Http.post(apiBase + "assign-task-users", params);
}

export function assignTaskToGroupUsers(params) {
  return Http.post(apiBase + "assign-task-group-users", params);
}

export function assignTaskV2(params) {
  return Http.post(apiBase + "assign-task-v2", params);
}

export function getTaskAssignees(params) {
  return Http.post(apiBase + "get-task-assignees", params);
}

export function unassignTask(params) {
  return Http.post(apiBase + "unassign-task", params);
}

export function unassignGroupTask(params) {
  return Http.post(apiBase + "unassign-group-task", params);
}

export function reassignTask(params) {
  return Http.post(apiBase + "reassign-task", params);
}

export function cancelScheduledTask(params) {
  return Http.post(apiBase + "cancel-scheduled-task", params);
}

export function getMembersDataForTask(params) {
  return Http.post(apiBase + "get-members-task-data-taskid", params);
}

export function markTaskAsCompletedReq(params) {
  return Http.post(apiBase + "update-my-task", params);
}

export function searchTask(params) {
  return Http.post(apiBase + "search-task", params);
}

export function getUserTask(params) {
  return Http.post(apiBase + "get-my-task", params);
}

export function getAssignedMembersListForTask(params) {
  return Http.post(apiBase + "get-members-by-taskid", params);
}

export function markAsReviewedTask(params) {
  return Http.post(apiBase + "mark-task-reviewed", params);
}

export function deleteTask(params) {
  return Http.post(apiBase + "delete-task", params);
}

// ai tasks
export function generateContentFromPrompt(params) {
  return Http.post(apiBase + "generate-content-task", params);
}

export function generateTaskContent(params) {
  return Http.post(apiBase + "generate-ai-tasks", params);
}

// folder structure api's
const apiBaseFolder = "/api/v1/enterprise/task-folders/";

export function fetchFolderContents(params) {
  return Http.post(apiBaseFolder + "get-folder-contents", params);
}

export function createNewFolder(params) {
  return Http.post(apiBaseFolder + "create-folder", params);
}

export function renameFolder(params) {
  return Http.post(apiBaseFolder + "rename-folder", params);
}

export function deleteFolder(params) {
  return Http.post(apiBaseFolder + "delete-folder", params);
}

export function deleteTaskFromFolder(params) {
  return Http.post(apiBaseFolder + "delete-task-from-folder", params);
}

// Soft Skills API's
const apiBaseSoftSkills = "/api/v1/enterprise/soft-skills/";

export function getJourneySkillsList() {
  return Http.get(apiBaseSoftSkills + "get-journey-skills-list");
}

export function getPopularScenariosList() {
  return Http.get(apiBaseSoftSkills + "get-popular-scenarios-list");
}

// Vocabulary Flashcards API
export function searchFlashcard(params) {
  return Http.post(apiBase + "search-flashcards", params);
}

export function regenerateFlashcard(params) {
  return Http.post(apiBase + "regenerate-flashcard", params);
}

// Read Task content upload (images, videos, PDFs)
export function getSignedUrlForTaskContent(fileName, fileType, fileSize) {
  return Http.post(apiBase + "get-signed-url-for-task-content", {
    fileName,
    fileType,
    fileSize,
  });
}

export function deleteUploadedTaskContent(fileName) {
  return Http.post(apiBase + "delete-uploaded-task-content", {
    fileName,
  });
}

export function uploadFileToS3(signedUrl, file, fileType) {
  return fetch(signedUrl, {
    method: "PUT",
    body: file,
    headers: {
      "Content-Type": fileType,
    },
  });
}